
<div class="container-fluid" *ngIf="!MarkCompleted_Status">
    <div class="row mt-5">
        <p>ADD New Field Visit</p>
    </div>
</div>

<div class="container-fluid" *ngIf="MarkCompleted_Status">
    <div class="row mt-5">
        <p style="color: red;">This Customer Account Marked as Completed..!</p>
    </div>
</div>

<div class="container-fluid" *ngIf="!MarkCompleted_Status">
    <div class="row">
        <div class="col-12">
            <form [formGroup]="FieldVisitForm">
                <div class="form-row">
                    <div class="form-group col-md-4">
                        <label for="">Field Visit ID</label>
                        <input type="text" placeholder="Auto generated ID" class="form-control"  disabled>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="">Account ID</label>
                        <select formControlName="account_id" class="form-control">
                            <option value="{{selectedAcc}}">{{selectedAcc}}</option>
                            <option *ngFor="let item of LinkedAccounts" [value]="item.acc_no">{{item.acc_no}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="">Field Visit Area</label>
                        <select class="form-control" formControlName="fieldvisitterritory" (change)="ontrtchange($event)">
                            <option value="">Choose</option>
                            <option *ngFor="let item of areaCodeList" [value]="item.areacode">{{item.areacode}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="">Field Visit Territory</label>
                      
                        <select class="form-control" formControlName="fieldvisitarea" (change)="onareachange($event)">
                            <option value="">Choose</option>
                            <option *ngFor="let item of fieldvisitCodeList" [value]="item.fvcode">{{item.fvcode}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="">Field Coordinators</label>
                        <select class="form-control" formControlName="assigned_coordinator">
                            <option value="">Choose</option>
                            <option *ngFor="let item of CoordinatorsList" [value]="item._id">{{item.name}}</option>
                        </select>
                    </div>


                    <div class="form-group col-md-4">
                        <label for="">POS</label>
                        <input type="text" placeholder="POS" class="form-control" formControlName="pos" >
                    </div>
                    <div class="form-group col-md-4">
                        <label for="">Product Name</label>
                        <input type="text" placeholder="Product" class="form-control" formControlName="product_type" >
                    </div>
                    
                    <div class="form-group col-md-4">
                        <label for="">First Address</label>
                        <input type="text" placeholder="First address" class="form-control" formControlName="firstaddress" >
                    </div>
                    <div class="form-group col-md-4">
                        <label for="">Second Address</label>
                        <input type="text" placeholder="Second address" class="form-control" formControlName="secondaddress" >
                    </div>
                    <div class="form-group col-md-4">
                        <label for="">Field Visit Request Date</label>
                        <input type="date" placeholder="Requested Date" class="form-control" formControlName="fvrqdate" >
                    </div>
              
                    <div class="form-group col-md-4">
                        <label for="">Status</label>
                        <select formControlName="status" class="form-control">
                            <option value="">Choose</option>
                            <option value="done">Done</option>
                            <option value="not done">Not Done</option>
                            <option value="pending">Pending</option>
                            <option value="revisit">Revisit</option>
                        </select>
                    </div>


                    

                    
                    <div class="form-group col-md-12">
                        <label for="">Remarks</label>
                        <textarea name="" id="" cols="30" rows="5" placeholder="Remarks" class="form-control" formControlName="remarks"></textarea>
                    </div>
                    <!-- <div class="form-group col-md-4">
                        <label for="">FV done date</label>
                        <input type="date" placeholder="Requested Date" class="form-control" formControlName="FV_Done_Date" >
                    </div>

                    <div class="form-group col-md-4">
                        <label for="">Numbers obtained</label>
                        <input type="text" placeholder="Second address" class="form-control" formControlName="Numbers_Obtained" >
                    </div>

                    <div class="form-group col-md-12">
                        <label for="">FV Feedback</label>
                        <textarea name="" id="" cols="30" rows="5" placeholder="Remarks" class="form-control" formControlName="FV_Feedback"></textarea>
                    </div> -->
                    
                    <div class="form-group col-md-12">
                        <input type="file" class="custom-file-input" id="customFile" (change)="getFile($event)">
                        <label class="custom-file-label" for="customFile">Choose file</label>
                    </div>
                    <p *ngIf="uploaded">File Uploaded</p>
                </div>
                <div class="d-flex justify-content-end">
                    <button class="btn btn-sm btn-success" (click)="addNewFieldVisit()">ADD</button>
                </div>
            </form>        
        </div>
    </div>
</div>
  

<div class="container-fluid">
    <hr>
    <div class="row" style="text-align: end; margin:10px;">
        <p style="font-size: 14px;"><b>Field Visit List</b></p>
    </div>
    <div class="row">
        <div class="col-12">
            <ag-grid-angular #agGrid 
                    style="width: auto; height: 300px;"
                    class="ag-theme-alpine"
                    [rowData]="FieldVisitList"
                    [rowSelection]="'multiple'"
                    [columnDefs]="FieldVisitcolumnDefs"
                    [pagination]="true"
                    (gridReady)="onGridReady($event)" 
                    (click)="onGetSelectedRowId()" >
            </ag-grid-angular>
        </div>
    </div>
</div>